/* eslint-disable max-len */
import React from 'react';

const SizeSmallIcon = props => (
  <svg width={19} height={19} viewBox="0 0 19 19" {...props}>
    <path
      fillRule="evenodd"
      d="M4.8 4c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2H3v1.8a.2.2 0 0 1-.2.2h-.6a.2.2 0 0 1-.2-.2V4.2c0-.11.09-.2.2-.2h2.6zM17 6.8a.2.2 0 0 1-.2.2h-.6a.2.2 0 0 1-.2-.2V5h-1.8a.2.2 0 0 1-.2-.2v-.6c0-.11.09-.2.2-.2h2.6c.11 0 .2.09.2.2v2.6zM14.2 15a.2.2 0 0 1-.2-.2v-.6c0-.11.09-.2.2-.2H16v-1.8c0-.11.09-.2.2-.2h.6c.11 0 .2.09.2.2v2.6a.2.2 0 0 1-.2.2h-2.6zM2 12.2c0-.11.09-.2.2-.2h.6c.11 0 .2.09.2.2V14h1.8c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2H2.2a.2.2 0 0 1-.2-.2v-2.6zM7.2 9h4.6c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2v-.6c0-.11.09-.2.2-.2z"
    />
  </svg>
);

export default SizeSmallIcon;
